export const {
  graphqlUri
} = (window as any)._env;